<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.VIEW') }} {{ $t('PLANNINGS.TASKS.BLOCK.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      <errors class="pt-2" :errors="errorsWithoutForm" />
      <v-row>
        <v-col cols="12" xs="12" md="3">{{ $t('EMPLOYEES.ITEM') }}:</v-col>
        <v-col cols="12" xs="12" md="9">
          <span class="text-subtitle-1">{{ employeeTitle }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" md="3">{{ $t('ITEM.DATE') }}</v-col>
        <v-col cols="12" xs="12" md="9">{{
          selectedDay.date | dateFormat
        }}</v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <block-day-form
        v-model="task"
        :errors="errors.getAll()"
        editable
        @valid="valid = $event"
        @update-prop="clearErrorByName($event)"
      />
      <v-card-actions>
        <v-btn outlined depressed color="grey" @click="cancel">
          {{ $t('BUTTON.CANCEL') }}
        </v-btn>
        <v-spacer />
        <v-btn depressed color="error" @click="removeDialog = true">
          {{ $t('BUTTON.DELETE') }}
        </v-btn>
        <v-btn depressed color="primary" :disabled="!valid" @click="update">
          {{ $t('BUTTON.UPDATE') }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
    <v-dialog v-if="removeDialog" v-model="removeDialog" max-width="500px">
      <v-card flat dense>
        <v-card-title>
          {{ $t('PLANNINGS.TASKS.BLOCK.REMOVE') }}
          <v-spacer />
          <v-btn icon @click="removeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <remove-block-day-list
            v-if="isShowRemoveDayList"
            @remove="remove"
            @close="removeDialog = !removeDialog"
          />
          <v-card v-else class="mx-auto" max-width="500" tile flat>
            <v-card-actions class="px-0">
              <v-btn
                outlined
                depressed
                large
                color="grey"
                @click.prevent="removeDialog = !removeDialog"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-spacer />
              <v-btn depressed color="error" large @click.prevent="remove()">
                {{ $t('BUTTON.DELETE') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { dateFormat } from '@/modules/_global/filters';
import Errors from '@/modules/_global/_components/Errors';
import BlockDayForm from '../forms/BlockDay/BlockDayForm';

export default {
  name: 'ViewBlockDayTask',

  filters: {
    dateFormat
  },

  components: {
    Errors,
    BlockDayForm,
    RemoveBlockDayList: () =>
      import('@/modules/plannings/components/BlockDay/RemoveBlockDayList.vue')
  },

  mixins: [errors, i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      task: {},
      error: null,
      removeDialog: false
    };
  },

  computed: {
    ...mapState('planning', ['selectedDay', 'selectedEntity']),

    employeeTitle() {
      const first = this.selectedEntity.first_name || '';
      const last = this.selectedEntity.last_name || '';

      return `${first} ${last}`.trim();
    },

    isShowRemoveDayList() {
      return !this.selectedDay.past && this.task.is_multi_task;
    },

    errorsWithoutForm() {
      return ['date_from', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('planning', [
      'getBlockTask',
      'updateBlockTask',
      'destroyBlockTask'
    ]),

    refreshData() {
      this.getBlockTask({ taskId: this.id }).then(({ data }) => {
        this.task = data;
      });
    },

    cancel() {
      this.$emit('cancel');
    },

    remove(question = 0) {
      this.destroyBlockTask({ taskId: this.id, question })
        .then(({ data }) => {
          this.$emit('removed', { ...data });
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        })
        .finally(() => {
          this.removeDialog = false;
        });
    },

    update() {
      this.updateBlockTask({
        taskId: this.id,
        task: this.task
      })
        .then(({ data }) => {
          this.$emit('updated', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
